<template>
  <!--  <el-dialog title="" :visible.sync="dialogVisible" width="100%" append-to-body>-->
  <div v-if="dialogVisible" class="mapping-report-wrapper">
    <div class="page-container flex-column">
      <i class="el-icon-close close_btn" @click="dialogVisible = false"></i>
      <div class="page-wrapper">
        <p class="text-center ft-title">{{ title }}</p>
        <CheckBox v-show="headers.length === 0" :default-checked="defChecked" :data="checkData" @confirm="setHeaders" />
        <div v-show="headers.length > 0" class="flex-row item-center">
          <div class="mb5 mr20">
            <el-button type="primary" size="mini" @click="exportExcel">生成Excel报告</el-button>
          </div>
          <div class="mb5 mr20 text-center ft-blue pointer" @click="showEdit('增加列')">
            <div><i class="el-icon-plus"></i></div>
            <div>增加一列</div>
          </div>
          <div class="mb5 mr20 text-center ft-blue pointer" @click="showEdit('批量修改')">
            <div><i class="el-icon-edit"></i></div>
            <div>批量修改内容</div>
          </div>
        </div>
      </div>
      <div class="col-1 scroll">
        <el-table
          v-if="headers.length > 0"
          :data="list"
          height="100%"
          border
          @selection-change="handleSelectionChange"
          @cell-click="clickCell"
        >
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            v-for="(header, i) in headers"
            :key="i"
            :column-key="header"
            :prop="header"
            :label="header"
            sortable
          >
            <template slot-scope="scope">
              <div v-if="scope.row.editing !== header" :title="scope.row[header]" class="text_ellipsis edit_cell">
                {{ scope.row[header] }} <i class="edit_cell_icon el-icon-edit"></i>
              </div>
              <div v-else>
                <el-input
                  v-model="scope.row[header]"
                  placeholder="请输入内容"
                  autofocus
                  clearable
                  size="mini"
                  @blur="scope.row.editing = ''"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <EditTableCol :visible.sync="editVisible" :headers="headers" :title="dialogTitle" :confirm="confirm" />
    </div>
    <!--  </el-dialog>-->
  </div>
</template>
<script>
import CheckBox from '../../../project/src/components/CheckBox.vue'
import EditTableCol from '../../../misc/src/EditTableCol.vue'
import { average, download, initialize2DArray, objectPickBy, formatWorkbook } from '../../../project/src/constant/utils'

const dateFormat = require('dateformat')

export default {
  components: { CheckBox, EditTableCol },
  data() {
    return {
      list: [],
      headers: [],
      title: '',
      multipleSelection: [],
      editVisible: false,
      dialogTitle: '',
      editTarget: {},
      checkData: [
        '姓名',
        '进展',
        '进展时间',
        '公司',
        '目前职位',
        '意向',
        '性别',
        '长期意向',
        '地域',
        '曾任职公司',
        '离职意愿度',
        '当前薪酬',
        '工作经历',
        '简介',
        '教育经历',
        '出生年月',
        '婚育',
        '职能模块',
        '细分职能',
        '擅长方向',
        '个性标签',
        '职级',
        '管理职级',
        '专业职级',
        '业绩',
        '行业',
        '规模',
        '管理基金数量',
        '任职期',
        '管理基金',
        '投资风格',
        '口碑打分',
        '部门',
        '组别',
        '学历标签',
        '语言标签',
        '沟通日志',
        '备注',
        '本科院校',
        '硕士院校',
      ],
      dialogVisible: false,
      defChecked: [],
      project: null,
    }
  },
  methods: {
    async show(project, list) {
      this.headers = []
      this.project = project
      this.title =
        `${project['客户公司']}-` +
        `${project['部门'] ? `${project['部门']}-` : ''}` +
        `${project['项目名称']}-阿尔法咨询-报告`

      this.list = list.map(radish => {
        Object.keys(radish).forEach(key => {
          const value = radish[key]
          if (!value) return (radish[key] = '')
          if (['offers', 'recommends', 'interviews', 'toworks'].includes(key)) return
          if (key === 'grades' && value.length > 0) {
            radish['口碑打分'] = {
              业绩: [],
              管理能力: [],
              专业高度: [],
              资源: [],
              口碑: [],
              情商: [],
            }
            if (!radish['口碑打分'].exist) radish['口碑打分'].exist = true
            value.forEach(grade => {
              ;['业绩', '管理能力', '专业高度', '资源', '口碑', '情商'].forEach(type => {
                if (grade[type]) {
                  radish['口碑打分'][type].push(grade[type])
                }
              })
            })
          } else if (Array.isArray(value)) {
            radish[key] = value.join('；')
          }
        })
        this.computeRadishGrades(radish)
        this.computeRadishStatus(radish)
        radish.editing = ''
        return radish
      })

      this.dialogVisible = true
      await this.$nextTick()
      this.defChecked = ['姓名', '进展', '进展时间', '公司', '目前职位']
    },
    computeRadishGrades(radish) {
      if (radish['口碑打分'] && radish['口碑打分'].exist) {
        delete radish['口碑打分'].exist
        Object.keys(radish['口碑打分']).map(type => {
          radish['口碑打分'][type] = average(...radish['口碑打分'][type])
        })
        radish['口碑打分'] = JSON.stringify(radish['口碑打分']).replace(/({|}|")/g, '')
      } else {
        radish['口碑打分'] = ''
      }
    },
    computeRadishStatus(radish) {
      if (radish.toworks && radish.toworks.length > 0) {
        const info = radish.toworks[radish.toworks.length - 1]
        radish['进展'] = '到岗'
        radish['进展时间'] = info.到岗日期
        return
      }
      if (radish.offers && radish.offers.length > 0) {
        const info = radish.offers[radish.offers.length - 1]
        radish['进展'] = 'offer'
        radish['进展时间'] = info.offer签订日期
        return
      }
      if (radish.interviews && radish.interviews.length > 0) {
        const info = radish.interviews[radish.interviews.length - 1]
        radish['进展'] = `${info.round}面`
        radish['进展时间'] = info.面试时间
        return
      }
      if (radish.recommends && radish.recommends.length > 0) {
        const info = radish.recommends[radish.recommends.length - 1]
        radish['进展'] = `推荐`
        radish['进展时间'] = info.updatedAt && dateFormat(info.updatedAt, 'yyyy.mm.dd')
        return
      }
      radish['进展'] = ''
      radish['进展时间'] = ''
    },
    setHeaders(headers) {
      this.headers = headers
    },
    async exportExcel() {
      if (this.exportPending) return
      const { title, headers, multipleSelection } = this
      if (multipleSelection.length === 0) {
        return this.$message('请先勾选导出数据')
      }
      try {
        this.exportPending = true
        await this.exportCore(this.project, this.multipleSelection, headers, title)
      } catch (error) {
        this.$message.error((error.response && error.response.message) || error.message)
      }
      this.exportPending = false
      this.dialogVisible = false
    },
    async exportCore(project, radishes, headers, title) {
      const fields = headers
      const name = title
      this.$message.info('正在生成...')
      const url = await app
        .service('radish')
        .exportProjectReportExcel({ name, radishes, fields, projectId: this.project && this.project._id })
      download({ url })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    showEdit(title) {
      if (title === '批量修改' && this.multipleSelection.length === 0) {
        return this.$message('请先勾选需要修改的数据')
      }
      this.dialogTitle = title
      this.editVisible = true
    },
    confirm(editHeader, editValue) {
      const { dialogTitle } = this
      if (dialogTitle === '增加列') {
        this.headers.push(editHeader)
      }
      const list = dialogTitle === '批量修改' ? this.multipleSelection : this.list
      list.forEach(radish => {
        radish[editHeader] = editValue
      })
      this.editVisible = false
    },
    clickCell(row, column, cell, event) {
      const editTarget = this.editTarget
      const rowId = row._id
      const col = column.columnKey
      if (rowId === editTarget.rowId && col === editTarget.col) return
      this.editTarget.row && (this.editTarget.row.editing = '')
      this.editTarget = {
        rowId,
        col,
        row,
      }
      row.editing = col
    },
  },
}
</script>
<style>
.mapping-report-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 60px;
  bottom: 0;
  background-color: white;
  z-index: 1000;
}

.close_btn {
  position: absolute;
  right: 1em;
  font-size: 1.5em;
  color: grey;
  cursor: pointer;
}

.close_btn:hover {
  color: rgb(78, 164, 252);
}
</style>
